import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';
import { UserProfile } from '../model/user-profile';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(private http: HttpClient) { }

  getUserProfileMe(): Observable<UserProfile[]> {
    
    let url=`${environment.api.uri}v1.0/userprofile/me`;
    return this.http.get<UserProfile[]>(url);
  }

}
